module.exports = __webpack_public_path__ + "img/4.55ec4b3b.jpg";